import { render } from "./MakePurchaseMaterial.vue?vue&type=template&id=183cf7e3&scoped=true"
import script from "./MakePurchaseMaterial.vue?vue&type=script&lang=js"
export * from "./MakePurchaseMaterial.vue?vue&type=script&lang=js"

import "./MakePurchaseMaterial.vue?vue&type=style&index=0&id=183cf7e3&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183cf7e3"]])

export default __exports__